import { STATUS_TAGS } from "../../../utils/constants";

// Helpers for unified access across ItemModel and Order

export const getOrderNo = (order: any): string =>
  order.order_number || order.orderNo || `ORD-${order.id}`;

export const getCustomerName = (order: any): string =>
  order.customer?.company_out_name || order.customerName || order.customer_code || "店舗未設定";

export const getOrderDate = (order: any): string => {
  if (order.sales_date) {
    return String(order.sales_date).split("T")[0];
  }
  return order.orderDate || "";
};

export const getDeliveryDate = (order: any): string =>
  order.deliveryDate || getOrderDate(order);

export const getTotalAmount = (order: any): number => {
  if (typeof order.total_amount === "string") {
    return parseFloat(order.total_amount) || 0;
  }
  if (typeof order.totalAmount === "number") {
    return order.totalAmount;
  }
  return 0;
};

export const getStatusConfig = (statusStr: string) => {
  const config = (STATUS_TAGS as any)[statusStr.toLocaleLowerCase()];
  if (config) return config;
  return { color: "blue", label: statusStr || "未設定" };
};
